import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { LoggingService, LogLevel } from '@app/services/logging.service';

@Injectable()
export class PwaRecoverService {
  static readonly COMPONENT_NAME = 'PwaRecoverService';

  constructor(
    private updates: SwUpdate,
    private loggingService: LoggingService
  ) {
  }

  init() {
    this.updates.unrecoverable.subscribe(event => {
      this.notifyUser(
        'An error occurred that we cannot recover from:\n' +
        event.reason +
        '\n\nReloading the page.'
      );
    });
    this.loggingService.log(LogLevel.DEBUG, PwaRecoverService.COMPONENT_NAME, `[PWA]: Initialized PwaRecoverService`);
  }


  notifyUser(message: string) {
    alert(message);
    document.location.reload();
  }
}
